// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__miJ1G"};